import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import "./Contact.css";

const Contact = () => {
  const formRef = useRef(null);
  const [statusMessage, setStatusMessage] = useState("");

  const sendEmail = (e) => {
    e.preventDefault();
    

    const serviceID = "ramanshrutilaya";
    const templateID = "template_o4s6fd8";
    const publicKey = "77joLZn1_eKfepcG4";

    emailjs
      .sendForm(serviceID, templateID, formRef.current, publicKey)
      .then(
        (result) => {
          console.log(result.text);
          setStatusMessage("Your message was sent successfully!");
          e.target.reset();
        },
        (error) => {
          console.error(error.text);
          setStatusMessage("Oops, something went wrong. Please try again.");
        }
      );
  };

  return (
    <section className="contact-section">
      <h1>Contact/Inquiry</h1>
      <p>
        For any queries please fill out the form below and we will get back to you.
      </p>

      {/* CONTACT FORM */}
      <form ref={formRef} onSubmit={sendEmail} className="contact-form">
        <label htmlFor="user_name">Name</label>
        <input
          type="text"
          id="user_name"
          name="user_name"
          placeholder="Your Name"
          required
        />

        <label htmlFor="user_email">Email</label>
        <input
          type="email"
          id="user_email"
          name="user_email"
          placeholder="Your Email"
          required
        />

        <label htmlFor="user_phone">Phone</label>
        <input
          type="tel"
          id="user_phone"
          name="user_phone"
          placeholder="Your Phone Number"
        />


        <label htmlFor="message">Message</label>
        <textarea
          id="message"
          name="message"
          placeholder="How can we help you?"
          rows="4"
          required
        />

        <button type="submit">Send</button>

        {statusMessage && (
          <p className="status-message">{statusMessage}</p>
        )}
      </form>

      {/* CONTACT INFORMATION CARD */}
      <div className="contact-info-card">
        <h2>Contact Information</h2>
        <p><strong>Email:</strong> ramanshrutilaya@gmail.com</p>
        <p><strong>Website:</strong> https://shrutilayafinearts.com/</p>
      </div>
    </section>
  );
};

export default Contact;
